<template>
	<div
		:title="showNativeTitle ? slotText : undefined"
		class="option-item w-full border-b bg-slate-50 px-4 py-3 last:border-b-0"
		:class="{
			'text-secondary-900': state === SelectOptionState.NoSelection,
			'text-primary-600 font-bold': state === SelectOptionState.Selected,
			'text-secondary-400': state === SelectOptionState.NotSelected,
			'cursor-not-allowed bg-slate-100 select-none': disabled,
			'hover:text-primary-600 hover:bg-primary-50 cursor-pointer hover:shadow-md':
				!disabled,
		}"
	>
		<slot></slot>
	</div>
</template>

<script setup lang="ts">
import { SelectOptionState } from '@/enums/SelectOptionState'
import { vnodesToText } from '@/views/NewSession/PlanVersions/utils'
import { computed, type PropType, useSlots } from 'vue'

const slots = useSlots()

const slotText = computed(() => vnodesToText(slots.default?.()))

defineProps({
	state: String as PropType<SelectOptionState>,
	disabled: Boolean,
	showNativeTitle: {
		type: Boolean,
		default: true,
	},
})
</script>
